export default __webpack_public_path__ + "static/media/UniversLTStd-CnObl.985b2b54.otf";